import React, { useState, useEffect, lazy, Suspense } from "react";
import "./MovieList.css";
// import MovieDetail from "./MovieDetail";
export default function MovieList({ fetchUrl, title, poster_path }) {
  const MovieDetail = lazy(() => import("./MovieDetail"));

  const baseUrl = "https://api.themoviedb.org/3";
  const [movies, setMovies] = useState([]);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const fetchData = async (url) => {
    try {
      const response = await fetch(baseUrl + url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchMovieListData = async () => {
      const data = await fetchData(fetchUrl);
      console.log(data);
      setMovies(data.results);
    };
    fetchMovieListData();
  }, [fetchUrl]);
  //hàm click trailer
  const handleMovieClick = (movie) => {
    if (selectedMovie && selectedMovie.id === movie.id) {
      setSelectedMovie(null);
    } else {
      setSelectedMovie(movie);
    }
  };
  return (
    <div className="movie-lists">
      <h2 className="movie-list-title">{title}</h2>
      <div className="posters-list">
        {movies.map((movie) => (
          <img
            key={movie.id}
            src={`https://image.tmdb.org/t/p/original${
              poster_path ? movie.poster_path : movie.backdrop_path
            }`}
            alt={movie.title}
            onClick={() => handleMovieClick(movie)}
            className="poster-list"
          />
        ))}
      </div>
      {selectedMovie && (
        <Suspense fallback={<p style={{ alignItems: "center" }}>Loading...</p>}>
          <MovieDetail movieData={selectedMovie} />
        </Suspense>
      )}
    </div>
  );
}
